module.exports = __webpack_public_path__ + "media/images/glanz-e88d8b3976c94d66701b5bde189bce30.png";